import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cachesTitle: {
    id: 'frontbucket.pipelines.common.caches.title',
    description:
      'The title of the caches section in the pipeline list action menu',
    defaultMessage: 'Dependency caches',
  },

  noCachesHeader: {
    id: 'frontbucket.pipelines.common.noCaches.header',
    description: 'Header text when no caches are present',
    defaultMessage: "You haven't added any dependency caches yet",
  },
  noCachesDescription: {
    id: 'frontbucket.pipelines.common.noCaches.description',
    description: 'Description when no caches are present',
    defaultMessage:
      'Speed up your build by caching your dependencies. {learnMoreLink}',
  },
  learnMoreButton: {
    id: 'frontbucket.pipelines.common.learnMoreButton',
    description: 'Text for the learn more button',
    defaultMessage: 'Learn more',
  },
  deleteCachesTooltip: {
    id: 'frontbucket.pipelines.common.deleteCachesTooltip',
    description: 'Tooltip text for the delete caches button',
    defaultMessage: 'Delete caches',
  },
  deleteCacheModalTitle: {
    id: 'frontbucket.pipelines.common.deleteCacheModalTitle',
    description: 'Title for the delete cache modal',
    defaultMessage: 'Delete cache{pluralSuffix}',
  },
  deleteCacheModalBodyGroup: {
    id: 'frontbucket.pipelines.common.deleteCacheModalBodyGroup',
    description: 'Body text for the delete cache modal when deleting a group',
    defaultMessage:
      'Are you sure you want to delete the {cacheName} cache and all associated versions?',
  },
  deleteCacheModalBodySingle: {
    id: 'frontbucket.pipelines.common.deleteCacheModalBodySingle',
    description:
      'Body text for the delete cache modal when deleting a single version',
    defaultMessage:
      'Are you sure you want to delete {versionLabel} the {parentCacheName} cache created on {creationDate}?',
  },
  cacheItemToDeleteLabel: {
    id: 'frontbucket.pipelines.common.cacheItemToDeleteLabel',
    description: 'Label for the cache item to delete',
    defaultMessage: 'version {label} of',
  },
  cancelButton: {
    id: 'frontbucket.pipelines.common.cancelButton',
    description: 'Text for the cancel button',
    defaultMessage: 'Cancel',
  },
  deleteButton: {
    id: 'frontbucket.pipelines.common.deleteButton',
    description: 'Text for the delete button',
    defaultMessage: 'Delete',
  },
  cachesButton: {
    id: 'frontbucket.pipelines.common.cachesButton',
    description: 'Text for the caches button',
    defaultMessage: 'Caches',
  },
});
